import { createContext, ReactElement, useContext } from "react";
import GetMainDados, { ResponseMembrosCheckin } from "../services/getMainDados";

const ServicesContextCRM = createContext<ResponseMembrosCheckin>(null);

export const ProviderServicesCRMContext = ({ children }: { children: ReactElement | ReactElement[] }) => {

  const services = GetMainDados();

  return (
    <ServicesContextCRM.Provider value={services}>
      {children}
    </ServicesContextCRM.Provider>
  )
}

export const useServicesCRM = () => {
  const context = useContext(ServicesContextCRM);
  return context;
}
